import { render, staticRenderFns } from "./team.vue?vue&type=template&id=b288548e&scoped=true&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "./team.vue?vue&type=style&index=0&id=b288548e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b288548e",
  null
  
)

export default component.exports